import React, { useState } from 'react'
import { patchShortlistEntries } from 'submission/lib/shortlist-api'

type Props = {
  open: boolean
  dealId: string
  roundId: number
  onClose: () => void
  onAdded: () => void
}

const AddEntryModal: React.FC<Props> = ({
  open,
  dealId,
  roundId,
  onClose,
  onAdded,
}) => {
  const [privyId, setPrivyId] = useState('')
  const [walletAddress, setWalletAddress] = useState('')
  const [depositAmount, setDepositAmount] = useState('')
  const [rank, setRank] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (!open) return null

  const submit = async () => {
    if (!privyId.trim() || !walletAddress.trim()) {
      setError('privy_id and wallet_address are required')
      return
    }
    setSubmitting(true)
    setError(null)
    try {
      await patchShortlistEntries(dealId, roundId, [
        {
          privy_id: privyId.trim(),
          action: 'manual_add',
          wallet_address: walletAddress.trim(),
          deposit_amount: depositAmount.trim() || undefined,
          rank: rank === '' ? undefined : Number(rank),
        },
      ])
      onAdded()
      onClose()
    } catch (e: any) {
      setError(e?.message ?? 'Failed to add entry')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded p-6 w-[480px]">
        <h3 className="text-lg font-medium mb-4">Add wallet to round</h3>
        <label className="block mb-3 text-sm">
          <span className="block text-slate-600 mb-1">privy_id *</span>
          <input
            value={privyId}
            onChange={(e) => setPrivyId(e.target.value)}
            className="border rounded px-2 py-1 w-full"
          />
        </label>
        <label className="block mb-3 text-sm">
          <span className="block text-slate-600 mb-1">wallet_address *</span>
          <input
            value={walletAddress}
            onChange={(e) => setWalletAddress(e.target.value)}
            className="border rounded px-2 py-1 w-full"
            placeholder="0x…"
          />
        </label>
        <label className="block mb-3 text-sm">
          <span className="block text-slate-600 mb-1">
            deposit_amount (big-int string, optional)
          </span>
          <input
            value={depositAmount}
            onChange={(e) => setDepositAmount(e.target.value)}
            className="border rounded px-2 py-1 w-full"
          />
        </label>
        <label className="block mb-3 text-sm">
          <span className="block text-slate-600 mb-1">rank (optional)</span>
          <input
            type="number"
            value={rank}
            onChange={(e) => setRank(e.target.value)}
            className="border rounded px-2 py-1 w-full"
          />
        </label>
        {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
        <div className="flex gap-2 justify-end">
          <button
            type="button"
            className="px-3 py-1 border rounded"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-3 py-1 bg-blue-600 text-white rounded disabled:opacity-50"
            onClick={submit}
            disabled={submitting}
          >
            {submitting ? 'Adding…' : 'Add'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddEntryModal
